import { useEffect, useState } from 'react';
import '../../../css/FBTeamHomePage.css';
import RosterBox from '../../../components/RosterBox';
import AFCteamLogos from '../../../assets/AFCteamLogos';
import NFCteamLogos from '../../../assets/NFCteamLogos';
import { generateRivalryVotes } from "../../../utils/rivalryVotes";

const CommandersHome = () => {
    const [selectedTeam, setSelectedTeam] = useState('');
    const [voteSubmitted, setVoteSubmitted] = useState(false);
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [selectedOpponent, setSelectedOpponent] = useState(null);
    const [selectedMatchupVote, setSelectedMatchupVote] = useState('');
    const [matchupVoteSubmitted, setMatchupVoteSubmitted] = useState(false);
    const [matchupHistory, setMatchupHistory] = useState({});
    const [depthChart, setDepthChart] = useState({
        offense: [],
        defense: [],
        specialTeams: []
    });

    const { team1Percent, team2Percent } = generateRivalryVotes(
        "The Commanders",
        "The Cowboys"
    );

    const selectedOpponentBorderColor = '#5A1414';
    const teamFillClass = 'commanders-fill';

    const selectedTeamDisplay =
        selectedTeam === 'commanders' ? 'The Commanders' :
        selectedTeam === 'cowboys' ? 'The Cowboys' :
        '';

    const homeOpponents = [
        { id: 'cowboys-home', name: 'Dallas Cowboys', logo: NFCteamLogos["Dallas Cowboys"], location: 'Home', fillClass: 'cowboys-fill' },
        { id: 'giants-home', name: 'New York Giants', logo: NFCteamLogos["New York Giants"], location: 'Home', fillClass: 'giants-fill' },
        { id: 'eagles-home', name: 'Philadelphia Eagles', logo: NFCteamLogos["Philadelphia Eagles"], location: 'Home', fillClass: 'eagles-fill' },
        { id: 'falcons-home', name: 'Atlanta Falcons', logo: NFCteamLogos["Atlanta Falcons"], location: 'Home', fillClass: 'falcons-fill' },
        { id: 'bengals-home', name: 'Cincinnati Bengals', logo: AFCteamLogos["Cincinnati Bengals"], location: 'Home', fillClass: 'bengals-fill' },
        { id: 'texans-home', name: 'Houston Texans', logo: AFCteamLogos["Houston Texans"], location: 'Home', fillClass: 'texans-fill' },
        { id: 'colts-home', name: 'Indianapolis Colts', logo: AFCteamLogos["Indianapolis Colts"], location: 'Home', fillClass: 'colts-fill' },
        { id: 'rams-home', name: 'Los Angeles Rams', logo: NFCteamLogos["Los Angeles Rams"], location: 'Home', fillClass: 'rams-fill' },
        { id: 'seahawks-home', name: 'Seattle Seahawks', logo: NFCteamLogos["Seattle Seahawks"], location: 'Home', fillClass: 'seahawks-fill' }
    ];

    const awayOpponents = [
        { id: 'cowboys-away', name: 'Dallas Cowboys', logo: NFCteamLogos["Dallas Cowboys"], location: 'Away', fillClass: 'cowboys-fill' },
        { id: 'giants-away', name: 'New York Giants', logo: NFCteamLogos["New York Giants"], location: 'Away', fillClass: 'giants-fill' },
        { id: 'eagles-away', name: 'Philadelphia Eagles', logo: NFCteamLogos["Philadelphia Eagles"], location: 'Away', fillClass: 'eagles-fill' },
        { id: 'cardinals-away', name: 'Arizona Cardinals', logo: NFCteamLogos["Arizona Cardinals"], location: 'Away', fillClass: 'cardinals-fill' },
        { id: 'jaguars-away', name: 'Jacksonville Jaguars', logo: AFCteamLogos["Jacksonville Jaguars"], location: 'Away', fillClass: 'jaguars-fill' },
        { id: 'vikings-away', name: 'Minnesota Vikings', logo: NFCteamLogos["Minnesota Vikings"], location: 'Away', fillClass: 'vikings-fill' },
        { id: 'fortyniners-away', name: 'San Francisco 49ers', logo: NFCteamLogos["San Francisco 49ers"], location: 'Away', fillClass: 'fortyniners-fill' },
        { id: 'titans-away', name: 'Tennessee Titans', logo: AFCteamLogos["Tennessee Titans"], location: 'Away', fillClass: 'titans-fill' }
    ];

    const handleOpponentClick = (opponent) => {
        setSelectedOpponent(opponent);
        setSelectedMatchupVote('');
        setMatchupVoteSubmitted(false);
    };

    const handleMatchupVoteSubmit = () => {
        if (!selectedOpponent || !selectedMatchupVote || matchupVoteSubmitted) return;
        setMatchupVoteSubmitted(true);
    };

    const matchupVoteDisplay =
        selectedMatchupVote === 'commanders' ? 'Commanders' :
        selectedMatchupVote === 'opponent' ? selectedOpponent?.name :
        '';

    const currentMatchup =
        selectedOpponent && matchupHistory["Commanders"]
            ? matchupHistory["Commanders"][selectedOpponent.name]
            : null;

    const getWinnerClass = (teamScore, opponentScore, side) => {
        if (teamScore === opponentScore) return '';
        if (side === 'team' && teamScore > opponentScore) return teamFillClass;
        if (side === 'opponent' && opponentScore > teamScore) return selectedOpponent?.fillClass || '';
        return '';
    };

    const handleVote = () => {
        if (!selectedTeam || voteSubmitted) return;
        setVoteSubmitted(true);
        handleSaveFavorites(starredPlayers, isTeamFavorite, selectedTeam);
    };

    const handleSaveFavorites = async (
        players = starredPlayers,
        teamFav = isTeamFavorite,
        vote = selectedTeam
    ) => {
        const fav = {
            teamName: "Washington Commanders",
            teamLogo: NFCteamLogos["Washington Commanders"],
            isTeamFavorite: teamFav,
            rivalVote: vote,
            players: players.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
            //const response = await fetch('http://localhost:5001/api/favorites/save', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

            const data = await response.json();
            console.log("Favorites saved", data);
        } catch (err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
        const fetchFavorites = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=Washington Commanders`, {
                //const res = await fetch('http://localhost:5001/api/favorites/get?team=Washington Commanders', {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                });

                if (!res.ok) {
                    console.log("No favorites found or error fetching");
                    return;
                }

                const data = await res.json();

                setIsTeamFavorite(data.team?.isFavorite || false);
                setSelectedTeam(data.rivalVote || '');
                setVoteSubmitted(!!data.rivalVote);

                const playerKeys = data.players
                    .filter(p => p.isFavorite)
                    .map(p => p.name);

                setStarredPlayers(playerKeys);
            } catch (err) {
                console.error("Error fetching favorites", err);
            }
        };

        fetchFavorites();
    }, []);

    useEffect(() => {
        const url = process.env.PUBLIC_URL + "/static/depthCharts.json";

        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                const teamChart = data["Commanders"] || {
                    offense: [],
                    defense: [],
                    specialTeams: []
                };

                setDepthChart(teamChart);
            })
            .catch((err) => {
                console.log("depth chart error:", err);
                setDepthChart({
                    offense: [],
                    defense: [],
                    specialTeams: []
                });
            });
    }, []);

    useEffect(() => {
        const url = process.env.PUBLIC_URL + "/static/NFLteamMatchups.json";

        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                setMatchupHistory(data);
            })
            .catch((err) => {
                console.log("matchup history error:", err);
                setMatchupHistory({});
            });
    }, []);

    return (
        <div>
            <section className="fb-top-row">
                <section className="fb-team-info">
                    <img
                        className="fb-team-logo"
                        src={NFCteamLogos["Washington Commanders"]}
                        alt="Washington Commanders"
                    />
                    <div className="fb-team-text">
                        <div className="fb-title-row">
                            <h1>Washington Commanders</h1>
                            <button
                                type="button"
                                className="fb-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal);
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="fb-label">Division:</span> NFC East</p>
                        <p><span className="fb-label">Head Coach:</span> Dan Quinn</p>
                        <p><span className="fb-label">Offensive Coordinator:</span> David Blough</p>
                        <p><span className="fb-label">Defensive Coordinator:</span> Daronte Jones</p>
                        <p><span className="fb-label">Special Teams Coordinator:</span> Larry Izzo</p>
                    </div>
                </section>

                <section className="fb-poll-box">
                    <h2>The Rival Game: Who Will Win?</h2>
                    {!voteSubmitted ? (
                        <>
                            <div className="fb-poll-options">
                                <button
                                    type="button"
                                    className={`fb-poll-option-btn ${selectedTeam === 'commanders' ? 'selected-poll-team' : ''}`}
                                    onClick={() => setSelectedTeam('commanders')}
                                >
                                    <img
                                        src={NFCteamLogos["Washington Commanders"]}
                                        alt="Washington Commanders"
                                        className="fb-poll-logo"
                                    />
                                </button>
                                <button
                                    type="button"
                                    className={`fb-poll-option-btn ${selectedTeam === 'cowboys' ? 'selected-poll-team' : ''}`}
                                    onClick={() => setSelectedTeam('cowboys')}
                                >
                                    <img
                                        src={NFCteamLogos["Dallas Cowboys"]}
                                        alt="Dallas Cowboys"
                                        className="fb-poll-logo"
                                    />
                                </button>
                            </div>
                            <button
                                className="fb-vote-button"
                                type="button"
                                onClick={handleVote}
                                disabled={!selectedTeam}
                            >
                                Vote!
                            </button>
                        </>
                    ) : (
                        <div className="fb-results-box">
                            <p className="fb-voted-text">You voted for... {selectedTeamDisplay}!</p>
                            <div className="fb-poll-results">
                                <div className="fb-poll-result-row">
                                    <img
                                        src={NFCteamLogos["Washington Commanders"]}
                                        alt="Washington Commanders"
                                        className="fb-poll-result-logo"
                                    />
                                    <div className="fb-progress-bar">
                                        <div className="fb-progress-fill commanders-fill" style={{ width: `${team1Percent}%` }}></div>
                                    </div>
                                    <span className="fb-progress-percent">{team1Percent}%</span>
                                </div>
                                <div className="fb-poll-result-row">
                                    <img
                                        src={NFCteamLogos["Dallas Cowboys"]}
                                        alt="Dallas Cowboys"
                                        className="fb-poll-result-logo"
                                    />
                                    <div className="fb-progress-bar">
                                        <div className="fb-progress-fill cowboys-fill" style={{ width: `${team2Percent}%` }}></div>
                                    </div>
                                    <span className="fb-progress-percent">{team2Percent}%</span>
                                </div>
                            </div>
                        </div>
                    )}
                </section>
            </section>

            <div className="fb-team-content">
                <section className="fb-left-content">
                    <h2>Roster</h2>
                    <RosterBox
                        teamName="Commanders"
                        sport="football"
                        favoritePlayers={starredPlayers}
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />

                    <h2>Schedule</h2>
                    <div className="roster-box">
                        <div className="roster-header">
                            <span>Date</span>
                            <span>Game</span>
                            <span className="pos-col">Time</span>
                        </div>
                        <div className="roster-list">
                            <p className="roster-empty">
                                The 2026 NFL schedule hasn't been released yet. It's expected to drop on May 2026.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="fb-middle-content">
                    <h2>2026 Opponents</h2>
                    <div className="fb-box fb-opponents-box">
                        <h2>Home:</h2>
                        <div className="fb-opponents-grid">
                            {homeOpponents.map((opponent) => (
                                <button
                                    key={opponent.id}
                                    type="button"
                                    className={`fb-opponent-placeholder ${selectedOpponent?.id === opponent.id ? 'selected-opponent' : ''}`}
                                    onClick={() => handleOpponentClick(opponent)}
                                    style={selectedOpponent?.id === opponent.id ? { borderColor: selectedOpponentBorderColor } : {}}
                                >
                                    <img
                                        src={opponent.logo}
                                        alt={opponent.name}
                                        className="fb-opponent-logo"
                                    />
                                </button>
                            ))}
                        </div>

                        <h2>Away:</h2>
                        <div className="fb-opponents-grid">
                            {awayOpponents.map((opponent) => (
                                <button
                                    key={opponent.id}
                                    type="button"
                                    className={`fb-opponent-placeholder ${selectedOpponent?.id === opponent.id ? 'selected-opponent' : ''}`}
                                    onClick={() => handleOpponentClick(opponent)}
                                    style={selectedOpponent?.id === opponent.id ? { borderColor: selectedOpponentBorderColor } : {}}
                                >
                                    <img
                                        src={opponent.logo}
                                        alt={opponent.name}
                                        className="fb-opponent-logo"
                                    />
                                </button>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="fb-future-content">
                    <h2>Game Center</h2>
                    <div className="fb-box">
                        <details className="fb-dropdown" open>
                            <summary>Past 5 Games</summary>
                            <div className="fb-dropdown-content">
                                {!selectedOpponent ? (
                                    <p>Click on an opponent logo to show matchup history.</p>
                                ) : currentMatchup ? (
                                    <>
                                        <div className="fb-game-center-table-header">
                                            <span>Date</span>

                                            <div className="fb-game-center-logo-head">
                                                <img
                                                    src={NFCteamLogos["Washington Commanders"]}
                                                    alt="Washington Commanders"
                                                />
                                            </div>

                                            <div className="fb-game-center-logo-head">
                                                <img
                                                    src={selectedOpponent.logo}
                                                    alt={selectedOpponent.name}
                                                />
                                            </div>
                                        </div>

                                        <div className="fb-game-center-table">
                                            {currentMatchup.pastGames.map((game, index) => (
                                                <div
                                                    key={index}
                                                    className={`fb-game-center-row ${index < currentMatchup.pastGames.length - 1 ? 'with-border' : ''}`}
                                                >
                                                    <span>{game.date}</span>
                                                    <span className={`fb-game-center-score ${getWinnerClass(game.teamScore, game.opponentScore, 'team')}`}>
                                                        {game.teamScore}
                                                    </span>
                                                    <span className={`fb-game-center-score ${getWinnerClass(game.teamScore, game.opponentScore, 'opponent')}`}>
                                                        {game.opponentScore}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>

                                        <p className="fb-game-center-alltime">
                                            All-Time:{' '}
                                            <span className={`fb-game-center-score ${teamFillClass}`}>
                                                {currentMatchup.allTime.teamWins}
                                            </span>
                                            -
                                            <span className={`fb-game-center-score ${selectedOpponent?.fillClass || ''}`}>
                                                {currentMatchup.allTime.opponentWins}
                                            </span>
                                            -
                                            <span className="fb-game-center-score">
                                                {currentMatchup.allTime.ties}
                                            </span>
                                        </p>
                                    </>
                                ) : (
                                    <p>No matchup history available for this opponent yet.</p>
                                )}
                            </div>
                        </details>

                        <details className="fb-dropdown" open>
                            <summary>Matchup Vote</summary>
                            <div className="fb-dropdown-content">
                                {!selectedOpponent ? (
                                    <p>Click on an opponent logo to vote on that matchup.</p>
                                ) : !matchupVoteSubmitted ? (
                                    <div className="fb-matchup-vote-wrap">
                                        <div className="fb-matchup-vote-options">
                                            <button
                                                type="button"
                                                className={`fb-poll-option-btn ${selectedMatchupVote === 'commanders' ? 'selected-poll-team' : ''}`}
                                                onClick={() => setSelectedMatchupVote('commanders')}
                                            >
                                                <img
                                                    src={NFCteamLogos["Washington Commanders"]}
                                                    alt="Washington Commanders"
                                                    className="fb-poll-logo"
                                                />
                                            </button>

                                            <button
                                                type="button"
                                                className={`fb-poll-option-btn ${selectedMatchupVote === 'opponent' ? 'selected-poll-team' : ''}`}
                                                onClick={() => setSelectedMatchupVote('opponent')}
                                            >
                                                <img
                                                    src={selectedOpponent.logo}
                                                    alt={selectedOpponent.name}
                                                    className="fb-poll-logo"
                                                />
                                            </button>
                                        </div>

                                        <button
                                            className="fb-vote-button"
                                            type="button"
                                            onClick={handleMatchupVoteSubmit}
                                            disabled={!selectedMatchupVote}
                                        >
                                            Vote!
                                        </button>
                                    </div>
                                ) : (
                                    <div className="fb-matchup-voted-result">
                                        <p className="fb-voted-text">You voted for: {matchupVoteDisplay}!</p>
                                        <img
                                            src={selectedMatchupVote === 'commanders' ? NFCteamLogos["Washington Commanders"] : selectedOpponent.logo}
                                            alt={matchupVoteDisplay}
                                            className="fb-poll-logo fb-matchup-voted-logo"
                                        />
                                    </div>
                                )}
                            </div>
                        </details>
                    </div>
                </section>

                <section className="fb-depth-bottom">
                    <h2>Depth Charts</h2>
                    <div className="fb-box">
                        <details className="fb-dropdown">
                            <summary>Offense</summary>
                            <div className="fb-dropdown-content">
                                {depthChart.offense.length === 0 ? (
                                    <p>No offensive depth chart available.</p>
                                ) : (
                                    <div className="fb-depth-table">
                                        <div className="fb-depth-table-header">
                                            <span className="fb-depth-pos-head">Pos</span>
                                            <span>Starter</span>
                                            <span>2nd</span>
                                            <span>3rd</span>
                                            <span>4th</span>
                                        </div>

                                        {depthChart.offense.map((group, index) => (
                                            <div key={index} className="fb-depth-table-row">
                                                <span className="fb-depth-pos">{group.position}</span>
                                                <span>{group.players[0] || '-'}</span>
                                                <span>{group.players[1] || '-'}</span>
                                                <span>{group.players[2] || '-'}</span>
                                                <span>{group.players[3] || '-'}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </details>

                        <details className="fb-dropdown">
                            <summary>Defense</summary>
                            <div className="fb-dropdown-content">
                                {depthChart.defense.length === 0 ? (
                                    <p>No defensive depth chart available.</p>
                                ) : (
                                    <div className="fb-depth-table">
                                        <div className="fb-depth-table-header">
                                            <span className="fb-depth-pos-head">Pos</span>
                                            <span>Starter</span>
                                            <span>2nd</span>
                                            <span>3rd</span>
                                            <span>4th</span>
                                        </div>

                                        {depthChart.defense.map((group, index) => (
                                            <div key={index} className="fb-depth-table-row">
                                                <span className="fb-depth-pos">{group.position}</span>
                                                <span>{group.players[0] || '-'}</span>
                                                <span>{group.players[1] || '-'}</span>
                                                <span>{group.players[2] || '-'}</span>
                                                <span>{group.players[3] || '-'}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </details>

                        <details className="fb-dropdown">
                            <summary>Special Teams</summary>
                            <div className="fb-dropdown-content">
                                {depthChart.specialTeams.length === 0 ? (
                                    <p>No special teams depth chart available.</p>
                                ) : (
                                    <div className="fb-depth-table">
                                        <div className="fb-depth-table-header">
                                            <span className="fb-depth-pos-head">Pos</span>
                                            <span>Starter</span>
                                            <span>2nd</span>
                                            <span>3rd</span>
                                            <span>4th</span>
                                        </div>

                                        {depthChart.specialTeams.map((group, index) => (
                                            <div key={index} className="fb-depth-table-row">
                                                <span className="fb-depth-pos">{group.position}</span>
                                                <span>{group.players[0] || '-'}</span>
                                                <span>{group.players[1] || '-'}</span>
                                                <span>{group.players[2] || '-'}</span>
                                                <span>{group.players[3] || '-'}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </details>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default CommandersHome;